var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5C10.8 13.5 13.5 10.8 13.5 7.5C13.5 4.2 10.8 1.5 7.5 1.5C4.2 1.5 1.5 4.2 1.5 7.5C1.5 10.8 4.2 13.5 7.5 13.5ZM7.5 0C11.625 0 15 3.375 15 7.5C15 11.625 11.625 15 7.5 15C3.375 15 0 11.625 0 7.5C0 3.375 3.375 0 7.5 0ZM9.69407 10.1684C9.85028 10.4362 9.7642 10.7797 9.50016 10.9422C9.22626 11.1108 8.86724 11.0199 8.70652 10.7413L6.88381 7.58194C6.79615 7.42999 6.75 7.25765 6.75 7.08222V4.3125C6.75 4.00184 7.00184 3.75 7.3125 3.75C7.62316 3.75 7.875 4.00184 7.875 4.3125V6.77965C7.875 6.95671 7.92201 7.13059 8.01122 7.28352L9.69407 10.1684Z",
    fill: "#CED4DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.e9676e5be556701ee5b9b849b553adab.svg";
export { ForwardRef as ReactComponent };